// GraphQL operation strings for the Tasks feature.
//
// All ops route through the Lambda data source per the phase 1 backend
// (see CLAUDE.md and prompts/tasks-feature/backend.md).

const TASK_FIELDS = `
  taskId reportId managerId assignee
  title description
  status priority dueDate
  createdAt updatedAt completedAt
  createdBy isOrphaned
`

export const TASKS_FOR_PAIR = `
  query TasksForPair($reportId: ID!, $managerId: ID!, $statusFilter: String) {
    tasksForPair(reportId: $reportId, managerId: $managerId, statusFilter: $statusFilter) {
      ${TASK_FIELDS}
    }
  }
`

export const CREATE_TASK = `
  mutation CreateTask($input: CreateTaskInput!) {
    createTask(input: $input) {
      ${TASK_FIELDS}
    }
  }
`

export const UPDATE_TASK = `
  mutation UpdateTask($input: UpdateTaskInput!) {
    updateTask(input: $input) {
      ${TASK_FIELDS}
    }
  }
`

export const DELETE_TASK = `
  mutation DeleteTask($taskId: ID!, $reportId: ID!) {
    deleteTask(taskId: $taskId, reportId: $reportId) {
      ${TASK_FIELDS}
    }
  }
`

export const TASK_CREATED_FOR_PAIR = `
  subscription TaskCreatedForPair($reportId: ID!, $managerId: ID!) {
    taskCreatedForPair(reportId: $reportId, managerId: $managerId) {
      ${TASK_FIELDS}
    }
  }
`

export const TASK_UPDATED_FOR_PAIR = `
  subscription TaskUpdatedForPair($reportId: ID!, $managerId: ID!) {
    taskUpdatedForPair(reportId: $reportId, managerId: $managerId) {
      ${TASK_FIELDS}
    }
  }
`

export const TASK_DELETED_FOR_PAIR = `
  subscription TaskDeletedForPair($reportId: ID!, $managerId: ID!) {
    taskDeletedForPair(reportId: $reportId, managerId: $managerId) {
      ${TASK_FIELDS}
    }
  }
`

// User-scoped subscription used by the nav-bar badge. Fires on any task
// mutation where the viewer is the assignee, or (on reassignment) was the
// previous assignee — see backend/handlers/tasks.py::update_task and
// infra/modules/appsync/resolvers/subscription.task-me-filter.js.
export const TASK_FOR_ME_CHANGED = `
  subscription TaskForMeChanged {
    taskForMeChanged {
      ${TASK_FIELDS}
      previousAssignee
    }
  }
`
